<template>
  <div class="main_Container">
    <section class="p-4 detailsView">
      <div class="container-fluid">
        <div v-if="loading" class="data__loading">
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <main class="container" v-else>
          <figure class="card w-100">
            <blockquote class="card-body p-3 m-0">
              <div class="d-flex align-items-center gap-4">
                <div class="col">
                  <h5>{{ content.title }}</h5>
                  <p class="m-0">{{ content.description }}</p>
                </div>
                <div>
                  <router-link :to="`/admin/lessons/view_lesson/${$route.params.index}/${this.$route.params.video_id}`"
                    class="btn btn-view icon">
                    <i class="fas fa-arrow-left"></i>
                  </router-link>
                </div>
              </div>
            </blockquote>
          </figure>
          <figure class="card w-100" id="comment">
            <div class="card-header p-3">
              <h3 class="card-header-title text-muted">الردود</h3>
            </div>
            <blockquote class="card-body m-0 p-3 position-relative">
              <ul class="comments-replies-list p-0 m-0">
                <SingleCommentItem :comment="comment" v-if="comment.comment" />
                <li v-if="!comment.comment">
                  <div>
                    <p class="text-center text-muted">لم يتم العثور على التعليق المطلوب</p>
                  </div>
                </li>
              </ul>
              <!-- <div class="load-more" v-if="(comments.comments || []).length < comments.count">
                    <button class="btn btn-info">تحميل المزيد</button>
                  </div> -->
            </blockquote>
            <div class="card-footer p-3">
              <form class="w-100" @submit.prevent="createNewComment">
                <div class="d-flex flex-lg-row flex-column gap-2 gap-lg-3 align-items-end">
                  <div class="col-lg w-100">
                    <div class="form-group m-0">
                      <textarea class="form-control" id="reply-content" name="reply-content"
                        placeholder="اكتب ردك هنا.." required style="min-height: 50px" v-model="add_data.reply">
                      </textarea>
                    </div>
                  </div>
                  <div>
                    <button class="btn btn-dark" type="submit" :disabled="add_disabled || !add_data.reply">
                      <i class="fas fa-spinner fa-spin" v-if="add_disabled"></i>
                      ارسال ردك
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </figure>
        </main>
      </div>
    </section>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import SingleCommentItem from '@/components/SingleCommentItem.vue';
import { Timestamp } from '@firebase/firestore';

export default {
  name: 'VideoComments',
  data() {
    return {
      add_data: {},
      add_disabled: false,
    };
  },
  computed: {
    ...mapGetters('ViewVideoModule', ['content', 'loading', 'comment']),
    ...mapGetters('adminModule', ['getUser']),
    id() {
      return this.$route.params.video_id;
    },
    lesson_id() {
      return this.$route.params.index;
    },
    comment_id() {
      return this.$route.params.comment_id;
    },
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    async comment_id() {
      if (this.comment_id) {
        Promise.all([
          await this.getSingleVideo(this.id),
          await this.updateNotification(this.comment_id),
          this.getSelectedComment({
            video_id: this.id,
            comment_id: this.comment_id,
          }).then((result) => {
            if (!result) {
              this.$router.go(-1);
            }
          }),
        ]);
      }
    },
  },
  methods: {
    ...mapActions('ViewVideoModule', ['getSingleVideo', 'addReply', 'loadMoreReplies', 'getSelectedComment', 'updateNotification']),
    async createNewComment() {
      const user = this.getUser;
      const data = {
        comment: this.add_data.reply,
        comment_id: this.comment_id,
        created_date: Timestamp.now().toDate().toISOString(),
        created_at: new Date().toDateString(),

        content_id: this.id,
        user_id: user.uid,
        author: { avatar_url: user.photo, user_name: `${user.firstName} ${user.lastName}`, user_id: user.uid, grade: null, is_teacher: true },
      };

      await this.addReply({
        video_id: this.id,
        reply: data,
        path: this.$route.path,
        comment_id: this.comment_id,
      });
      // remove data
      this.add_data = {};
    },
    async loadMore() {
      await this.loadMoreReplies(this.id);
    },
  },
  async created() {
    Promise.all([
      await this.getSingleVideo(this.id).then((result) => {
        if (!result) {
          this.$router.go(-1);
        }
      }),
      await this.updateNotification(this.comment_id),
      this.getSelectedComment({
        video_id: this.id,
        comment_id: this.comment_id,
      }).then((result) => {
        if (!result) {
          this.$router.go(-1);
        }
      }),
    ]);
  },
  components: { SingleCommentItem },
};
</script>
